import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObject24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObject24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 4.5H5A1.5 1.5 0 0 0 3.5 6v12A1.5 1.5 0 0 0 5 19.5h6.5A1.5 1.5 0 0 0 13 18V6a1.5 1.5 0 0 0-1.5-1.5M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h6.5a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm11.25 4.25A.75.75 0 0 1 17 6.5h4.227a.75.75 0 0 1 0 1.5H17a.75.75 0 0 1-.75-.75M17 10a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObject24);
